import { useState, useSyncExternalStore } from "react";
import { Check, Download, Ellipsis, Plus, Share, SquarePlus } from "lucide-react";
import { itx } from "../translationItx/itx";
import { isAppleMobile, pwaInstallSnapshot, requestPwaInstall, subscribePwaInstall } from "./pwaInstall";
import "./MobileInstallHint.scss";

const t = (key: string, text: string) => itx(`mobileWarning.install.${key}`, text);

/** Installation belongs to the entry notice, rather than interrupting the plan. */
export function MobileInstallHint() {
  const { available, installed } = useSyncExternalStore(subscribePwaInstall, pwaInstallSnapshot);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState(false);
  if (installed) return null;
  const apple = isAppleMobile();
  if (!apple && !available && !pending && !error) return null;

  async function install() {
    setPending(true); setError(false);
    try { await requestPwaInstall(); }
    catch { setError(true); }
    finally { setPending(false); }
  }

  return <section className="mobileInstallHint" aria-labelledby="mobile-install-title" data-testid="mobile-install-hint">
    <h2 id="mobile-install-title">{t("title", "ESTADA auf dem Home-Bildschirm")}</h2>
    {apple ? <>
      <p>{t("safari", "Auf dem IPhone folge diesen Schritten:")}</p>
      <ol className="mobileInstallSteps">
        <li><div className="mobileInstallPicture" aria-hidden="true"><div className="mobileInstallToolbar"><Ellipsis /><Share className="highlight" /></div></div>
          <div><strong>{t("share", "Teilen öffnen")}</strong><span>{t("shareDetail", "Tippe auf das Teilen-Symbol. Je nach Safari-Ansicht findest du es zuerst unter „…“.")}</span></div></li>
        <li><div className="mobileInstallPicture" aria-hidden="true"><div className="mobileInstallMenu"><SquarePlus /><Plus className="highlight" /></div></div>
          <div><strong>{t("add", "Zum Home-Bildschirm")}</strong><span>{t("addDetail", "Wähle diesen Eintrag im Teilen-Menü. Scrolle bei Bedarf nach unten.")}</span></div></li>
        <li><div className="mobileInstallPicture" aria-hidden="true"><div className="mobileInstallApp"><img src={`${import.meta.env.BASE_URL}images/estada-app-192.png`} alt="" /><Check className="highlight" /></div></div>
          <div><strong>{t("confirm", "Hinzufügen bestätigen")}</strong><span>{t("confirmDetail", "Lass „Als Web-App öffnen“ eingeschaltet, falls angeboten, und tippe auf „Hinzufügen“.")}</span></div></li>
      </ol>
    </> : <>
      {(available || pending) && <button id="mobile-install-button" type="button" onClick={() => void install()} disabled={pending}>
        <Download aria-hidden="true" />{pending ? t("pending", "Installation wird geöffnet …") : t("button", "Zum Home-Bildschirm hinzufügen")}
      </button>}
      {error && <p role="status">{t("error", "Die Installation konnte nicht geöffnet werden. Du kannst ESTADA auch über das Browsermenü zum Home-Bildschirm hinzufügen.")}</p>}
    </>}
  </section>;
}
